import { objectOf, arrayOf } from "@altostra/type-validations";
import { boolean, number, string } from "@altostra/type-validations/lib/primitives";

export const isEngagementAppGroupIdFeatureFlagsInfoResult = objectOf({
  hits: number,
  data: arrayOf(
    objectOf({
      rollout_id: string,
      rollout_nst: string,
      feature_flag_name: string,
      feature_flag_description: string,
      feature_flag_id: string,
      feature_flag_properties: string,
      feature_flag_enabled: boolean,
    })
  ),
});
